export const QUERY_KEYS = {
  GET_USER_INFO: 'get-user-info',
  READ_PRODUCT: 'read-product',
  LIST_PRODUCTS: 'list-products',
  LIST_DETAILS: 'list-details',
  READ_DETAIL: 'read-detail',
  GET_META: 'get-meta',
  GET_USER_CREDIT: 'get-user-credit',
  GET_CREDIT_INFO: 'get-credit-info',
  LIST_IMAGE_GENERATIONS: 'list-image-generations',
  LIST_AI_STUDIO_GALLERIES: 'list-ai-studio-galleries',
  READ_AI_STUDIO_GALLERY_IMAGE: 'read-ai-studio-gallery-image',
  READ_BANNER: 'read-banner',
  LIST_BANNERS: 'list-banners',
  LIST_VARIATIONS: 'list-variations',
  READ_VARIATION: 'read-variation',
  LIST_AI_STUDIO_PRESETS: 'list-ai-studio-presets',
  LIST_VIDEOS: 'list-videos',
  READ_VIDEO: 'read-video',
} as const;

export const MUTATION_KEYS = {
  CREATE_PRODUCT: 'create-product',
  CREATE_AI_CHAT: 'create-ai-chat',
  UPDATE_PRODUCT: 'update-product',
  UPDATE_PRODUCT_MAIN_IMAGE: 'update-product-main-image',
  UPDATE_PRODUCT_IMAGE_INFO: 'update-product-image-info',
  DELETE_PRODUCTS: 'delete-products',
  DELETE_PRODUCT_ATTACHMENTS: 'delete-product-attachments',
  ADD_PRODUCT_ATTACHMENTS: 'add-product-attachments',
  CREATE_DETAIL: 'create-detail',
  SAVE_AS_DETAIL: 'save-as-detail',
  RENAME_DETAIL: 'rename-detail',
  DELETE_DETAIL: 'delete-detail',
  UPDATE_DETAIL: 'update-detail',
  UPDATE_MODULE: 'update-module',
  ISSUE_PRESIGNED_URL: 'issue-presigned-url',
  UPLOAD_TO_S3: 'upload-to-s3',
  UPDATE_DETAIL_V2: 'update-detail-v2',
  UPDATE_MODULE_V2: 'update-module-v2',
  UPDATE_COMPONENT_V2: 'update-component-v2',
  CREATE_IMAGE_GENERATION: 'create-image-generation',
  CREATE_VIDEO: 'create-video',
  CREATE_BANNER: 'create-banner',
  UPDATE_BANNER: 'update-banner',
  DELETE_BANNERS: 'delete-banners',
  CREATE_VARIATION: 'create-variation',
  UPDATE_VARIATION: 'update-variation',
  RENAME_VARIATION: 'rename-variation',
  DELETE_VARIATION: 'delete-variation',
  DELETE_SIZE_VARIATION: 'delete-size-variation',
  RESIZE_BANNER: 'resize-banner',
  CREATE_BANNER_AI_CHAT: 'create-banner-ai-chat',
  DELETE_VIDEOS: 'delete-videos',
} as const;
